import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Layers } from 'lucide-react';
import { ServiceCard } from './ServiceCard';

interface HomeServicesSectionProps {
  store: any;
  config: any;
}

function getHomeServices(store: any) {
  const all = store?.services ?? [];
  const defaultIds = store?.defaultServices as string[] | undefined;

  if (defaultIds?.length) {
    return defaultIds
      .slice(0, 3)
      .map((id) => all.find((s: { service: string }) => s.service === id))
      .filter(Boolean) as Array<{ service: string; image?: string }>;
  }

  return all.slice(0, 3);
}

export function HomeServicesSection({ store, config }: HomeServicesSectionProps) {
  const servicesToShow = useMemo(() => getHomeServices(store), [store]);
  const totalServices = store?.services?.length ?? 0;

  if (servicesToShow.length === 0) {
    return null;
  }

  return (
    <section className="wl7-home-services">
      <div className="wl7-container">
        <div className="wl7-home-services__head">
          <p className="wl7-eyebrow">Serviços</p>
          <h2 className="wl7-h2">Como podemos ajudar</h2>
        </div>

        <div className="wl7-home-services-grid">
          {servicesToShow.map((service, index) => (
            <ServiceCard
              key={`${service.service}-${index}`}
              service={service}
              config={config}
            />
          ))}

          <Link
            to="/servicos"
            className="wl7-home-service-more"
            aria-label="Ver todos os serviços"
          >
            <div className="wl7-home-service-more__icon">
              <Layers className="h-6 w-6" />
            </div>
            <div className="wl7-home-service-more__body">
              <h3 className="wl7-home-service-more__title">Ver todos</h3>
              <p className="wl7-home-service-more__text">
                {totalServices > 3
                  ? `+${totalServices - 3} serviços disponíveis`
                  : 'Conheça todos os nossos serviços'}
              </p>
            </div>
            <span className="wl7-home-service-more__arrow">
              <ArrowUpRight className="h-5 w-5" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
